import React from "react";

import Paragraph from "../paragraph";

import "./index.scss";

export default function Disclaimer ({text}) {
    return <Paragraph className="disclaimer-text" text={text}/>
}